import React, { useState, useEffect } from "react";
import { trackPageView } from "./tracking/track";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Depost } from "./components/depost";
import { Vip } from "./components/vip";
import { Services } from "./components/services";
import { Privacy } from "./components/privacy";
import { Rules } from "./components/rules";
import { Hotgame } from "./components/hotgame";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import useAppier from "./hooks/useAppier";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

// 解析 URL 中的 _ads 參數
function parseCurrentUriAds() {
  try {
    const url = new URL(window.location.href);

    // 專門處理 /g 路徑
    if (url.pathname === '/g') {
      const paramValue = url.search.substring(1); // 獲取問號後的所有內容
      if (paramValue) {
        // 可以在此添加額外的驗證邏輯
        return paramValue.split('&')[0]; // 只取第一個參數
      }
      return null;
    }

    // 其他路徑保持原樣
    return url.searchParams.get("_ads") || null;
  } catch (error) {
    console.error("Error parsing URL:", error.message);
    return null;
  }
}

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [adsValue, setAdsValue] = useState(null);
  const [currentPage, setCurrentPage] = useState("home"); // Add state for current page

  useAppier();

  useEffect(() => {
    trackPageView()
    setLandingPageData(JsonData); // 確保數據始終加載
    const adsStr = parseCurrentUriAds();
    console.log("parseCurrentUriAds:", adsStr); // 檢查 ads 值
    setAdsValue(adsStr);

    // Check URL path to determine which page to show
    const path = window.location.pathname;
    if (path === "/services") {
      setCurrentPage("services");
    } else if (path === "/privacy") {
      setCurrentPage("privacy");
    } else if (path === "/rules") {
      setCurrentPage("rules");
    } else if (path === "/home" || path === "/" || path === "/g") {
      setCurrentPage("home"); // 新增一個 404 狀態
    } else {
      setCurrentPage("notfound"); // 新增一個 404 狀態
    }

  }, []);

  // 添加條件渲染，確保數據加載前顯示載入中
  if (!landingPageData || Object.keys(landingPageData).length === 0) {
    return <div>Loading...</div>;
  }

  // Render different pages based on currentPage state
  const renderPage = () => {
    switch (currentPage) {
      case "services":
        return <Services data={landingPageData.Services} adsValue={adsValue} />;
      case "privacy":
        return <Privacy adsValue={adsValue} />;
      case "rules":
        return <Rules adsValue={adsValue} />;
      case "notfound":
        return <div style={{ textAlign: "center", padding: "50px" }}><h1>404 - Page Not Found</h1></div>;
      default:
        return (
          <>
            <Header data={landingPageData.Header} />
            <Hotgame data={landingPageData.Hotgame} />
            <Vip data={landingPageData.Vip} />
            <Depost data={landingPageData.Depost} />
            <Contact data={landingPageData.Contact} />
          </>
        );
    }
  };

  return (
    <div>
      <Navigation adsValue={adsValue} currentPage={currentPage} />
      {renderPage()}
    </div>
  );
};

export default App;